<div class="roles-content">
  <div class="roles-grid">
    <div
      *ngFor="let role of rolesData; let i = index"
      class="role-card"
      [class.active]="selectedRole === role.id"
      (click)="selectRole(role.id)">
      <div class="role-header">
        <div class="role-info">
          <div class="role-title-row">
            <h3>{{ role | serverTranslate : "names" }}</h3>
            <span
              (click)="showUserInRole(role, $event)"
              class="user-count cursor-pointer">
              {{ getUserCountForRole(role) }} {{ getUserCountText(getUserCountForRole(role)) }}
            </span>
          </div>
          <p class="role-description">{{ role | serverTranslate : "descriptions" }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
